import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCryptoEth = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1.125em",
	height: "1.125em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 20,
			cy: 20,
			r: 20,
			fill: "#EDF0F4"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.9454 8L19.7863 8.54043V24.221L19.9454 24.3797L27.224 20.0773L19.9454 8Z",
			fill: "#343434"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.9454 8L12.6667 20.0773L19.9454 24.3797V16.7688V8Z",
			fill: "#8C8C8C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.9454 25.7578L19.8558 25.8671V31.4528L19.9454 31.7146L27.2285 21.4576L19.9454 25.7578Z",
			fill: "#3C3C3B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.9454 31.7146V25.7578L12.6667 21.4576L19.9454 31.7146Z",
			fill: "#8C8C8C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.9454 24.3797L27.224 20.0773L19.9454 16.7688V24.3797Z",
			fill: "#141414"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.6667 20.0773L19.9454 24.3797V16.7688L12.6667 20.0773Z",
			fill: "#393939"
		})
	]
});
export default SvgCryptoEth;
